export const ALERT_ICONS = {
    success: 'confirmacao',
    error: 'error_circle_base',
};
